import { SITUACIONES, type Situacion } from './contrato';

export function Etiqueta({ situacion }: { situacion: Situacion }) {
  const s = SITUACIONES[situacion];
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${s.clase}`}
    >
      {s.rotulo}
    </span>
  );
}
